import { createContext } from 'react';
import ContactEntryPointsContextPropTypes from './ContactEntryPointsContextPropTypes';
import entryPointsConfig from './ContactEntryPointsConfig';

export default createContext<ContactEntryPointsContextPropTypes>(entryPointsConfig);
